import { Class} from '../utils'
import View from './View'
import AccordionDetailsLayout from './AccordionDetailsLayout'
import DetailItemsRenderer from './DetailItemsRenderer'

/**
 *
 * @class A default UI for Septima Search
 * @extends View
 * @constructs DefaultView
 * @param {Object} options DefaultView expects these properties:
 * @param options.input {string|Object} Name of DOM container in which to draw the input field OR jQuery object representing DOM container
 * @param [options.placeholder] {string} Place holder text displayed in the empty search input field
 *
 * @example
 * var view = new DefaultView(
 *   {
 *     input : 'septimasearch',
 *     placeholder : 'Search'
 *   });
 *
 */
export default Class (View, /**  @lends DefaultView# */{

  initialize: function (options) {
    if (typeof options.mouseover === 'undefined'){
      let isSafari = !!navigator.userAgent.match(/Version\/[\d.]+.*Safari/);
      if (isSafari){
        options.mouseover = false;
      }else{
        options.mouseover = true;
      }
    }
    options.detailsLayout =  new AccordionDetailsLayout(
      {
        detailItemsRenderer: new DetailItemsRenderer()
      }
    );

    View.prototype.initialize.apply(this, [options]);
  },

  CLASS_NAME: 'DefaultView'

});
